<template>
  <div id="ChoiceDialog">
    <el-dialog
      title="选择地区"
      width="1000px"
      append-to-body
      @close="closeDialog"
      :visible.sync="visible"
      :show="show"
      :close-on-click-modal="false"
    >
      <div class="ChoiceDialog_box">
        <div class="searchbox">
          <inputOne
            class="base_select_sty185 isdisable"
            name="搜索"
            :v-model="search"
            field="search"
            placeholder="输入助记码/编号/名称"
            @changeVal="dateChange"
            @keyup.enter.native="searchbtn"
          />
          <el-button type="primary" size="mini" icon="el-icon-search" @click="searchbtn">查询</el-button>
          <div class="Multiple_selection" v-if="ifshow">
            <el-checkbox-group v-model="checkList" @change="changecheckStop">
              <el-checkbox label="显示层次结构"></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <!-- <div v-if="isshows" class="imgloading">
        <div class="imgloading_box">
          <img src="@/assets/timg.gif" alt />
        </div>
        </div>-->
        <div class="table_box">
          <div class="Tree_box">
            <div v-show="iSshow" class="history_meter_box">
              <div class="sapnbox" id="boxX">
                {{ textname }}
                <!-- <span v-show="iconone" class="el-icon-close"></span> -->
                <!-- <span v-show="iconss" class="el-icon-plus" @click="Newlybtn"></span> -->
                <span class="el-icon-d-arrow-left" @click="remain"></span>
              </div>
              <div class="history_lists">
                <el-tree
                  :data="datas"
                  :props="defaultProps"
                  accordion
                  @node-click="handleNodeClick"
                  :highlight-current="false"
                  node-key="id"
                  icon-class="iconfont icon-file-close"
                ></el-tree>
              </div>
            </div>
            <!-- <div v-show="!iSshow" class="sapnbox2" @click="remain">
              <span class="el-icon-d-arrow-right"></span>
            </div>-->
          </div>
          <!-- <div
            @mousedown.stop.prevent="mouseDown"
            v-if="iSshow"
            class="asdzczc"
            style="cursor:e-resize"
          ></div>
          <div v-if="!iSshow" class="asdzczcs"></div>
          <div class="table_box_list">
            <el-table
              :data="tableData"
              @row-dblclick="rowdblclick"
              @row-click="rowclick"
              border
              style="width: 100%;"
              :height="300"
              class="tabone_sty"
              :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'14px',height:'37px',padding:'0',fontWeight: 'bold'}"
            >
              <el-table-column width="80" height="500" align="center" prop="BarCode" fixed="left">
                <template slot="header">
                  <i style="color:#2594ff;font-size:18px"></i>
                </template>
                <template slot-scope="scope">{{scope.$index +1 }}</template>
              </el-table-column>
              <el-table-column width="50" align="center" label="类型" v-if="IfShows">
                <template slot-scope="scope">
                  <i
                    :class="scope.row.IsDir?'el-icon-folder':'el-icon-tickets'"
                    style="color:#e9cb70;font-size:18px"
                  ></i>
                </template>
              </el-table-column>
            </el-table>
          </div>-->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import treehistory from "@/components/Addinput/tree/tree.vue";
// import InputOne from "@/components/base/InputOne/InputOne.vue";
import tool from "@/utils/tool.js";
export default {
  components: {
    // treehistory,
    // InputOne
  },
  data() {
    return {
      currentPages: 1, //当前页码
      totals: 0, //总页数
      pageSizes: 10, //每页显示数量
      visible: this.show, // 是否显示弹框
      search: "", // 条件查询
      checkList: 0, //时候显示层级结构数据 0 - 1
      ifshow: false, //是否显示 显示层级结构多选按钮
      datas: [], // tree 数据
      defaultProps: {
        children: "children",
        label: "label"
      },
      textname: "分类", //tree 名字
      iSshow: true, // 收起或者展开显示
      iSshow: true, // 是否可拖动tree显示
      tableData: [] // 表格数据
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 单击行
    rowclick() {},
    // 双击行
    rowdblclick() {},
    // 收起或者展开
    remain() {},
    // 点击tree
    handleNodeClick() {},
    // 搜索数据回填
    dateChange(data, text) {
      this[text] = data;
    },
    // 显示层级结构
    changecheckStop() {},
    // 查询
    searchbtn() {},
    // 关闭弹出框前回调
    closeDialog() {
      // this.isInner = "el-icon-s-tools";
      this.$emit("update:show", false);
      this.search = "";
    },
    // 拖拽改变宽度
    mouseDown(ev) {
      document.documentElement.addEventListener(
        "mousemove",
        this.mouse_move,
        true
      );
      const tagBox = document.getElementById("boxX");
      const iEvent = ev || event;
      this.dx = iEvent.clientX;
      this.dw = tagBox.offsetWidth;
      // if (iEvent.clientX > tagBox.offsetLeft + 10) {
      //     this.resizing = 'left';
      // }
    },
    mouse_move(ev) {
      const tagBox = document.getElementById("boxX");
      const iEvent = ev || event;
      // console.log(tagBox.style.width);
      if (tagBox.style.width >= 1000) {
        tagBox.style.width = "1000px";
      }
      tagBox.style.width = `${this.dw + (iEvent.clientX - this.dx)}px`;
    },
    mouseUp() {
      document.documentElement.removeEventListener(
        "mousemove",
        this.mouse_move,
        true
      );
    }
  },
  // 创建生命周期钩子函数
  mounted() {
    document.documentElement.addEventListener("mouseup", this.mouseUp, true);
  },
  created() {},
  watch: {
    show() {
      this.visible = this.show;
    }
  }
};
</script>

<style lang="less">
#ChoiceDialog {
  width: 100%;
  height: 100%;
  .ChoiceDialog_box {
    width: 100%;
    height: 100%;
    background-color: aqua;

    .table_box {
      display: flex;
      .Tree_box {
        .history_meter_box {
          width: 200px;
          height: 300px;
          background-color: aqua;
        }
      }
      .asdzczc {
        width: 10px;
        background-color: aqua;
        cursor: e-resize;
      }
      .asdzczcs {
        width: 10px;
      }
      .table_box_list {
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/ChoiceDialog/ChoiceDialog.vue